<template>
<div v-if="product" class="wrap wrap--products wrap--products-view">
    <!-- 헤더 -->
    <main-header :header-type="'shop'" :headerSecondary="'off'"></main-header>

    <!-- 메인 -->
    <main class="main" role="main">
        <div class="inner">
            <section class="product-view-container">
                <!-- 상품 상세: 요약 -->
                <section class="product-intro">
                    <!-- 상품 이미지 -->
                    <div class="product-intro__thumb">
                        <!-- 기본 이미지 -->
                        <div class="product-intro__thumb-main">
                            <img :src="product.images[showImageIndex]" alt="">
                        </div>
                        <!-- 추가 이미지 -->
                        <ul class="product-intro__thumb-lists">
                            <li v-for="(i, index) in 5" :key="index" @click="showImageIndex = index" class="product-intro__thumb-list">
                                <div class="product-intro__thumb-button" role="button" :aria-pressed="index == showImageIndex">
                                    <img v-if="product.images[index]" :src="product.images[index]" alt=""></div>
                            </li>
                        </ul>
                    </div>

                    <!-- 상품 가격 -->
                    <div class="product-intro__info">
                        <!-- 브랜드명 -->
                        <div class="product-intro__brand">
                            <span class="product-intro__brand-text product-intro__brand-text--bold" v-if="product.brand">{{ product.brand.name }}</span>
                            <router-link class="product-intro__brand-text product-intro__brand-text--home" :to="`/shop/stores/${product._store}`" v-if="hasStore">{{ product.store.meta.companyName }}</router-link>
                        </div>
                        <!-- 상품명 -->
                        <div class="product-intro__name">
                            <h1 class="product-intro__name-text">{{ product.name }}</h1>
                        </div>
                        <!-- 상품 요약 테이블 -->
                        <div class="product-intro__table">
                            <!-- 상품 가격 그룹 -->
                            <div class="product-intro__table-row-group">
                                <div class="product-intro__table-row">
                                    <div class="product-intro__table-th"><span class="th">판매가</span></div>
                                    <div class="product-intro__table-td">
                                        <span class="product-intro__price">
                                            <small v-if="product.discountEnabled" class="line">{{ product.price.format() }}원</small>
                                            <span v-if="product.discountEnabled" class="percent">{{ product.discountRate }}%</span>
                                            <span class="current"><em class="num">{{ product.salePrice.format() }}</em>원</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="product-intro__table-row">
                                    <div class="product-intro__table-th"><span class="th">업체가</span></div>
                                    <div class="product-intro__table-td">
                                        <span class="product-intro__price">
                                            <small v-if="product.discountEnabled" class="line">{{ product.companyPrice.format() }}원</small>
                                            <span v-if="product.discountEnabled" class="percent">{{ product.companyDiscountRate }}%</span>
                                            <span class="current"><em class="num">{{ product.companySalePrice.format() }}</em>원</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="product-intro__table-row">
                                    <div class="product-intro__table-th"><span class="th">배송비</span></div>
                                    <div class="product-intro__table-td">{{ product.deliveryMessage }}</div>
                                </div>
                            </div>
                            <!-- 상품 옵션 그룹 -->
                            <product-options v-model="cart.pickups" :product="product"></product-options>

                            <!-- 추가 상품 그룹 -->
                            <product-supplies v-model="cart.pickups" :product="product"></product-supplies>
                        </div>
                        <!-- 선택한 옵션 박스 그룹 -->
                        <div class="product-intro__option-box-group">
                            <!-- 옵션 박스 -->
                            <div v-for="(pickup, index) in cart.pickups" :key="index" class="product-option-box">
                                <button class="product-option-box__delete" type="button" @click="cart.pickups.splice(index, 1)"><span class="blind">삭제</span></button>
                                <span class="product-option-box__title">
                                    <span>{{ pickup.name }} <span v-if="pickup.stock == 0">(품절)</span></span>
                                </span>
                                <div class="product-option-box__flex">
                                    <!-- 옵션 수량 -->
                                    <div class="spinner">
                                        <button class="spinner__minus" type="button" @click="decQuantity(pickup)"></button>
                                        <input v-model="pickup.quantity" class="spinner__num" type="number" @change="changeQuantity(pickup)" :disabled="!pickup.stock">
                                        <button class="spinner__plus" type="button" @click="incQuantity(pickup)"></button>
                                    </div>
                                    <div class="product-option-box__price">
                                        <span class="price">
                                            <em v-if="scope.includes('company')" class="num">{{ (pickup.companySalePrice * pickup.quantity).format() }}원</em>
                                            <em v-else class="num">{{ (pickup.salePrice * pickup.quantity).format() }}원</em>
                                        </span>
                                    </div>
                                </div>
                                <div v-if="pickup._product && !pickup._option && !pickup._supply" class="product-option-box__flex">
                                    <input v-model="pickup.requestMessage" class="input input--wide" type="text" placeholder="상품요청사항">
                                </div>
                            </div>
                        </div>
                        <!-- 총 상품 금액 -->
                        <div class="product-intro__total">
                            <span class="price">총<em class="num">{{ totalAmount.format() }}</em>원</span>
                        </div>
                        <!-- 버튼 영역 -->
                        <div class="product-intro__buttons">
                            <a class="button button--border-orange" onclick="return false;" @click="addToCart"><span>장바구니</span></a>
                            <a class="button button--orange" @click="buyNow"><span>바로구매</span></a>
                        </div>
                        <div class="product-sidebar__methods">
                            <naver-pay button-key="E8FAC592-0582-4E64-B0A7-410385FFD5AA" :cart="cart"></naver-pay>
                        </div>
                    </div>

                    <!-- 할인쿠폰 -->
                    <div class="product-intro__coupon">
                        <span class="product-intro__coupon-title"><b>이 상품!</b> <br class="pc">할인가능쿠폰</span>
                        <product-coupons :_product="product._id" :_categories="[product._category, ...product.category._parents]" @click="openModalCoupon"></product-coupons>
                    </div>
                </section>

                <!-- 상품 상세: 콘텐츠 -->
                <section class="product-details">
                    <!-- 탭 메뉴 -->
                    <nav class="product-details__navigation">
                        <div class="product-details__navigation-inner">
                            <ul class="product-details__nav">
                                <li><a class="product-details__nav-tab" href="#main" data-tab-button="main" aria-pressed="true"><span>상품정보</span></a></li>
                                <li><a class="product-details__nav-tab" href="#review" data-tab-button="review" aria-pressed="false"><span>구매후기</span></a></li>
                                <li><a class="product-details__nav-tab" href="#qna" data-tab-button="qna" aria-pressed="false"><span>상품문의</span></a></li>
                                <li><a class="product-details__nav-tab" href="#delivery" data-tab-button="delivery" aria-pressed="false"><span>반품/교환</span></a></li>
                            </ul>
                        </div>
                    </nav>
                    <!-- 옵션 요약 사이드바 -->
                    <div class="product-details__sidebar">
                        <div class="product-sidebar" data-sidebar-fixed="off">
                            <div class="product-sidebar__contents">
                                <!-- 모바일 하단 옵션바 닫기 버튼 -->
                                <button class="product-sidebar__close" aria-pressed="false"><span class="blind">옵션 닫기</span><i class="arrow"></i></button>
                                <div class="product-sidebar__top">
                                    <span class="product-sidebar__title">{{ product.name }}</span>

                                    <!-- 상품 옵션 그룹 -->
                                    <product-options v-model="cart.pickups" :product="product" sidebar></product-options>

                                    <!-- 추가 상품 그룹 -->
                                    <product-supplies v-model="cart.pickups" :product="product" sidebar></product-supplies>

                                    <!-- 선택한 옵션 박스 그룹 -->
                                    <div class="product-sidebar__option-box-group">
                                        <!-- 옵션 박스 -->
                                        <div v-for="(pickup, index) in cart.pickups" :key="index" class="product-option-box">
                                            <button class="product-option-box__delete" type="button" @click="cart.pickups.splice(index, 1)"><span class="blind">삭제</span></button>
                                            <span class="product-option-box__title">{{ pickup.name }} <span v-if="pickup.stock == 0">(품절)</span></span>
                                            <div class="product-option-box__flex">
                                                <!-- 옵션 수량 -->
                                                <div class="spinner">
                                                    <button class="spinner__minus" type="button" @click="decQuantity(pickup)"></button>
                                                    <input v-model="pickup.quantity" class="spinner__num" type="number" @change="changeQuantity(pickup)" :disalbed="!pickup.stock">
                                                    <button class="spinner__plus" type="button" @click="incQuantity(pickup)"></button>
                                                </div>
                                                <div class="product-option-box__price">
                                                    <span class="price">
                                                        <em v-if="scope.includes('company')" class="num">{{ (pickup.companySalePrice * pickup.quantity).format() }}원</em>
                                                        <em v-else class="num">{{ (pickup.salePrice * pickup.quantity).format() }}원</em>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="product-sidebar__bottom">
                                    <div class="product-sidebar__total">
                                        <span class="price">총<em class="num">{{ totalAmount.format() }}</em>원</span>
                                    </div>
                                    <div class="product-sidebar__buttons">
                                        <a class="button button--border-orange" @click="addToCart"><span>장바구니</span></a>
                                        <a class="button button--orange" @click="buyNow"><span>바로구매</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 상품 상세 콘텐츠 -->
                    <div class="product-details__contents">
                        <!-- 상품 상세: 메인 -->
                        <div class="product-details__content">
                            <div id="main" class="product-detail-container" data-tab-contents="main">
                                <!-- 상품 정보 -->
                                <section class="product-sub" v-html="product.content">
                                </section>
                            </div>
                        </div>
                        <!-- 상품 상세: 구매후기 -->
                        <product-reviews :product="product"></product-reviews>

                        <!-- 상품 상세: 상품문의 -->
                        <product-inquires :product="product" @openModal="openModalInquiry"></product-inquires>

                        <!-- 상품 상세: 배송 -->
                        <div class="product-details__content">
                            <div id="delivery" class="product-delivery-container" data-tab-contents="delivery">
                                <div class="product-delivery">
                                    <div class="product-delivery__col">
                                        <span class="title">반품</span>
                                        <!-- subtitle 삭제 2020.12.24 -->
                                        <!-- <span class="subtitle">상품이 마음에 안 들어 돈으로 환불 받을 경우</span> -->
                                        <div class="table">
                                            <div class="tr">
                                                <div class="th">반품신청</div>
                                                <div class="td">구매자 책임사유시 반품/배송비 결제</div>
                                            </div>
                                            <div class="tr">
                                                <div class="th">발송하기</div>
                                                <div class="td">1~2일 이내 택배기사 방문</div>
                                            </div>
                                            <div class="tr">
                                                <div class="th">반품접수 완료</div>
                                                <div class="td">마켓쿵에 반품상품 전달</div>
                                            </div>
                                            <div class="tr">
                                                <div class="th">반품완료</div>
                                                <div class="td">확인 후 환불처리</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="product-delivery__col">
                                        <span class="title">교환</span>
                                        <!-- subtitle 삭제 2020.12.24 -->
                                        <!-- <span class="subtitle">주문상품과 다르게 배송되어 다른 상품과 바꿀때</span> -->
                                        <div class="table">
                                            <div class="tr">
                                                <div class="th">교환신청</div>
                                                <div class="td">구매자 책임사유시 반품/4 결제</div>
                                            </div>
                                            <div class="tr">
                                                <div class="th">발송하기</div>
                                                <div class="td">1~2일 이내 택배기사 방문</div>
                                            </div>
                                            <div class="tr">
                                                <div class="th">교환접수</div>
                                                <div class="td">마켓쿵에 교환상품 전달</div>
                                            </div>
                                            <div class="tr">
                                                <div class="th">상품 재배송</div>
                                                <div class="td">확인 후 교환</div>
                                            </div>
                                            <div class="tr">
                                                <div class="th">교환완료</div>
                                                <div class="td"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="product-delivery__col product-delivery__col--merged">
                                        <span class="title">주의사항</span>
                                        <ul class="ul">
                                            <li>미성년자가 물품을 구매하는 경우, 법정대리인이 동의하지 않으면 미성년자 본인 또는 법정대리인이 구매를 취소할 수 있습니다.</li>
                                            <li>안전검사 대상 공산품’을 구매하시는 경우 품질경영 및 공산품 안전관리법에 따른 안전검사 표시가 있는 제품인지 확인하시기 바랍니다.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>

        <!-- 장바구니 모달 -->
        <modal-cart ref="modal-cart"></modal-cart>
        <!-- 쿠폰받기 모달 -->
        <modal-coupon ref="modal-coupon"></modal-coupon>
        <!-- 문의하기 모달 -->
        <modal-inquiry ref="modal-inquire" :product="product"></modal-inquiry>
    </main>

    <!-- 푸터 -->
    <main-footer></main-footer>
</div>
</template>

<script>
import api from "@/api";

import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import ModalCart from "@/components/client/shop/modal-cart.vue";
import ModalCoupon from "@/components/client/shop/modal-coupon.vue";
import ModalInquiry from "@/components/client/shop/modal-inquiry.vue";
import ProductCoupons from "@/components/client/shop/product-coupons.vue";
import ProductOptions from "@/components/client/shop/product-options.vue";
import ProductSupplies from "@/components/client/shop/product-supplies.vue";
import ProductReviews from "@/components/client/shop/product-reviews.vue";
import ProductInquires from "@/components/client/shop/product-inquires.vue";

import NaverPay from "@/components/plugins/naver/naver-pay.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        ModalCart,
        ModalCoupon,
        ModalInquiry,
        ProductCoupons,
        ProductOptions,
        ProductSupplies,
        ProductReviews,
        ProductInquires,

        NaverPay
    },
    metaInfo() {
        return Object.assign({}, this.seo || {});
    },
    props:{
        _product: String
    },
    data() {
        return {
            seo: null,

            showModalCart: false,
            showModalCoupon: false,
            showModalInquiry: false,

            product: null,
            showImageIndex: 0,
            
            cart: {
                _product: this._product,
                pickups: []
            },
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        openModalCoupon(coupon) {
            this.$refs['modal-coupon'].coupon = coupon;
            this.$refs['modal-coupon'].open();
        },
        openModalInquiry() {
            this.$refs['modal-inquire'].open();
        },

        async init() {
            try {
                var { product } = await api.v1.shop.products.getProduct({ _id: this._product });

                this.product = product;
                this.seo = product.seoEnabled ? product.seo : null;

                if (!product.optionEnabled) {
                    this.cart.pickups.push({
                        ...product,
                        product,
                        _product: product._id,
                        name: "본품",
                        quantity: 1,
                    });
                }

                this.$nextTick(() => {
                    this.productView();
                });
            } catch (error) {
                console.error(error);
            }
        },

        productView() {
            this.stickyBar();
            this.mobileOptionToggle();
        },

        // 모바일 하단 상품옵션
        mobileOptionToggle() {
            let toggle = document.querySelector('.product-sidebar__close');
            toggle.addEventListener('click', function () {
                let state = this.getAttribute('aria-pressed');
                if (state === 'false') {
                    document.querySelector('.product-details__sidebar').setAttribute('data-sidebar-mobile', 'opened');
                    this.setAttribute('aria-pressed', 'true');
                } else {
                    document.querySelector('.product-details__sidebar').removeAttribute('data-sidebar-mobile');
                    this.setAttribute('aria-pressed', 'false');
                }
            });
        },

        // 상품 네비게이션 메뉴 & 사이드바 Sticky
        stickyBar() {
            const HEAD = document.querySelector('.header');
            // const parentElement = document.querySelector('.product-details__sidebar');
            const parentElement = document.querySelector('.product-details');
            const stickyElement = document.querySelector('.product-sidebar');
            const navElement = document.querySelector('.product-details__nav');
            const nav = document.querySelectorAll('.product-details__nav-tab');
            let scrollPos = 0;
            let ticking = false;
            let timeout = '';
            let absoluteTop = 0;
            let windowWidth = window.outerWidth;
            let windowHeight = window.innerHeight;
            let mobileWidth = 1024;
            let headerPrimaryHeight = 0;
            let length = 0;
            let borderGap = 3;

            window.addEventListener('scroll', scroll);
            window.addEventListener("resize", resize);

            animate();

            function animate() {
                windowWidth = window.outerWidth;
                windowHeight = window.innerHeight;

                stickyProductSideBar();
                stickyProductNavigation();
            }

            function scroll(){
                if(!ticking) {
                    window.requestAnimationFrame(function () {
                        animate();
                        ticking = false;
                    });
                    ticking = true;
                }
            }

            function resize(){    
                if(!timeout) {
                    timeout = setTimeout(function () {
                        timeout = null;
                        animate();
                    }, 66);
                }
            }
            

            // 사이드바
            function stickyProductSideBar(){
                scrollPos = window.scrollY || window.pageYOffset;
                absoluteTop = window.pageYOffset + parentElement.getBoundingClientRect().top;
                length = parentElement.offsetHeight - stickyElement.offsetHeight + absoluteTop;

                if(HEAD.getAttribute('data-header-sticky') === 'sticky'){
                    headerPrimaryHeight = HEAD.querySelector('.header-primary-container').clientHeight;
                    absoluteTop = absoluteTop - headerPrimaryHeight;
                    length = length - headerPrimaryHeight;

                    if(windowWidth > mobileWidth) {
                        stickyElement.style.height = (windowHeight - headerPrimaryHeight) + 'px';
                    }
                }

                if(scrollPos < absoluteTop) {
                    navElement.style.position = 'static';
                    navElement.style.top = '0';
                    if(windowWidth > mobileWidth) {
                        stickyElement.style.position = 'absolute';
                        stickyElement.style.top = '0';
                        stickyElement.style.bottom = 'auto';
                    }
                }else if(scrollPos > length) {
                    if(windowWidth > mobileWidth) {
                        stickyElement.style.position = 'absolute';
                        stickyElement.style.top = 'auto';
                        stickyElement.style.bottom = '0';
                    }
                }else{
                    navElement.style.position = 'fixed';
                    navElement.style.top = headerPrimaryHeight + 'px';
                    if(windowWidth > mobileWidth) {
                        stickyElement.style.position = 'fixed';
                        stickyElement.style.top = headerPrimaryHeight + 'px';
                        stickyElement.style.bottom = 'auto';
                    }
                }
            }

            // 네비게이션 메뉴
            function stickyProductNavigation(){
                nav.forEach(function(e) {
                    let section = document.querySelector(e.hash);
                    let sectionTop = window.pageYOffset + section.getBoundingClientRect().top - borderGap;

                    if(HEAD.getAttribute('data-header-sticky') === 'sticky'){
                        sectionTop = sectionTop - borderGap - HEAD.querySelector('.header-primary-container').clientHeight;
                    }
                    
                    if(sectionTop <= scrollPos && sectionTop + section.offsetHeight > scrollPos){
                        e.setAttribute('aria-pressed', 'true');
                    }else{
                        e.setAttribute('aria-pressed', 'false');
                    }
                });
            }

            nav.forEach(function(e){
                e.addEventListener('click', function(){
                    event.preventDefault();
                    let s = document.querySelector(e.hash);
                    let t = window.pageYOffset + s.getBoundingClientRect().top - 2;
                    if(HEAD.getAttribute('data-header-sticky') === 'sticky'){
                        t = t + borderGap - HEAD.querySelector('.header-primary-container').clientHeight;
                    }
                    window.scrollTo(0, t);
                });
            });
           
        },

        check(){
            if (!this.cart.pickups.length) throw new Error("구매하실 상품을 선택해주세요");

            var soldout = this.cart.pickups.find(pickup => pickup.stock == 0);
            if (soldout) throw new Error("품절된 상품입니다");

            return true;
        },

        ////////////////////////////////////////////////////////////////////////
        // 장바구니 담기
        ////////////////////////////////////////////////////////////////////////
        async addToCart() {
            try {
                if(this.check()){
                    if(this.accessToken) {
                        var { cart } = await api.v1.me.carts.postCart(this.cart);
                        
                        this.$store.dispatch("addToCart", cart.pickups.map(pickup => pickup._id));
        
                        this.$refs['modal-cart'].open();
                    }
                    
                }
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);

                let toggle = document.querySelector('.product-sidebar__close');
                document.querySelector('.product-details__sidebar').setAttribute('data-sidebar-mobile', 'opened');
                toggle.setAttribute('aria-pressed', 'true');
            }
        },

        ////////////////////////////////////////////////////////////////////////
        // 바로구매
        ////////////////////////////////////////////////////////////////////////
        async buyNow() {
            try {
                if(this.check()){
                    var { cart } = await api.v1.me.carts.postCart(this.cart);

                    this.$store.dispatch("addToCart", cart.pickups.map(pickup => pickup._id));
                    this.$store.dispatch("checkout", cart.pickups.map(pickup => pickup._id));

                    this.$router.push('/shop/order');
                }

            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);

                let toggle = document.querySelector('.product-sidebar__close');
                    document.querySelector('.product-details__sidebar').setAttribute('data-sidebar-mobile', 'opened');
                    toggle.setAttribute('aria-pressed', 'true');
            }
        },

        incQuantity(pickup) {
            if (pickup.quantity < pickup.stock) pickup.quantity++;
        },

        decQuantity(pickup) {
            if (1 < pickup.quantity) pickup.quantity--;
        },

        changeQuantity(pickup) {
            if (pickup.quantity < 1) pickup.quantity = 1;
            if (pickup.stock < pickup.quantity) pickup.quantity = pickup.stock;
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        totalAmount() {
            if (this.scope.includes('company')) {
                return this.cart.pickups.reduce((totalAmount, pickup) => {
                    return totalAmount + (pickup.companySalePrice * pickup.quantity);
                }, 0);
            }
            return this.cart.pickups.reduce((totalAmount, pickup) => {
                return totalAmount + (pickup.salePrice * pickup.quantity);
            }, 0);
        },
        hasStore() {
            return this.product?.store?.meta?.companyName;
        },
    },
}
</script>
